<template>
  <v-app>
    <div id="app">
      <nav-component></nav-component>
      <header-component></header-component>
        <v-content>
          <router-view/>
        </v-content>
      <footer-component></footer-component>
    </div>
  </v-app>
</template>

<script>

export default {
  name: 'App',
};
</script>

<style>

.tc {
  text-align: center; 
}

.flex {
  display: flex;
}

.space-around {
  justify-content: space-around;
}
</style>
